import { Observable } from 'rxjs';
import { AAGUID } from '@interticket/core';
import { ILivestreamStatus } from './livestream-status.interface';

export abstract class IMediaSource {

  abstract getStreamableEvents(): Observable<AAGUID[]>;
  abstract getLivestreamStatus(eventId: AAGUID): Observable<ILivestreamStatus>;

}
